import React from 'react';
import { Check, Lock, Trash2 } from 'lucide-react';

const WizardProgressBar = ({ 
  steps, 
  currentStep, 
  validSteps, 
  completedSteps, 
  onStepClick,
  isOnline,
  onClearDraft,
  data,
  validations 
}) => {
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4 overflow-x-auto">
          <nav className="flex space-x-2 sm:space-x-4 md:space-x-6 lg:space-x-8" aria-label="Progress">
          {steps.map((step, stepIdx) => {
            const isCompleted = completedSteps.includes(step.id);
            const isCurrent = currentStep === step.id;
            const isValid = validSteps.has(step.id);
            
            // Verifica se possiamo navigare a questo step verificando tutti i prerequisiti
            const canNavigate = () => {
              if (step.id === 1) return true; // Step 1 sempre accessibile
              
              // Per step 2 (prodotti), verifica che ci sia un cliente
              if (step.id === 2) {
                return validations?.customer ? validations.customer(data) : true;
              }
              
              // Per step 3 (pagamento), verifica cliente E prodotti
              if (step.id === 3) {
                const hasCustomer = validations?.customer ? validations.customer(data) : true;
                const hasProducts = validations?.products ? validations.products(data) : true;
                return hasCustomer && hasProducts;
              }
              
              // Per step 4 (riepilogo), verifica tutti
              if (step.id === 4) {
                const hasCustomer = validations?.customer ? validations.customer(data) : true;
                const hasProducts = validations?.products ? validations.products(data) : true;
                const hasPayment = validations?.payment ? validations.payment(data) : true;
                return hasCustomer && hasProducts && hasPayment;
              }
              
              return isValid;
            };
            
            const actuallyValid = canNavigate();
            
            return (
              <button
                key={step.id}
                onClick={() => actuallyValid && onStepClick(step.id)}
                disabled={!actuallyValid}
                className={`relative flex items-center space-x-2 sm:space-x-3 px-2 sm:px-3 md:px-4 py-2 rounded-lg transition-all duration-200 whitespace-nowrap ${
                  isCurrent
                    ? 'text-gray-700 border-2 wizard-button-border'
                    : isCompleted
                    ? 'bg-green-50 text-green-700 border border-green-200 hover:bg-green-100'
                    : actuallyValid
                    ? 'text-gray-600 hover:bg-gray-50 border wizard-button-border'
                    : 'text-gray-400 cursor-not-allowed border border-gray-100'
                }`}
                style={isCurrent ? {backgroundColor: '#fcfbd6'} : {}}
              >
                {/* Icona step */}
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  isCurrent
                    ? 'text-white'
                    : isCompleted
                    ? 'bg-green-600 text-white'
                    : actuallyValid
                    ? 'bg-gray-200 text-gray-600'
                    : 'bg-gray-100 text-gray-400'
                }`}
                style={isCurrent ? {backgroundColor: '#c48f75'} : {}}>
                  {isCompleted ? (
                    <Check className="w-4 h-4" />
                  ) : !actuallyValid ? (
                    <Lock className="w-4 h-4" />
                  ) : (
                    <span className="text-sm font-semibold">{step.id}</span>
                  )}
                </div>

                {/* Titolo step */}
                <div className="flex flex-col items-start">
                  <span className={`text-sm font-medium ${
                    isCurrent ? 'text-gray-900' : 
                    isCompleted ? 'text-green-900' : 
                    actuallyValid ? 'text-gray-900' : 'text-gray-400'
                  }`}>
                    {step.title}
                  </span>
                  <span className={`text-xs ${
                    isCurrent ? 'text-gray-600' : 
                    isCompleted ? 'text-green-600' : 
                    actuallyValid ? 'text-gray-500' : 'text-gray-400'
                  }`}>
                    {isCurrent ? 'In corso' : 
                     isCompleted ? 'Completato' : 
                     actuallyValid ? 'Disponibile' : 'Bloccato'}
                  </span>
                </div>

                {/* Linea di connessione - rimossa per evitare overflow */}
              </button>
            );
          })}
          </nav>
          
        </div>

        {/* Indicatore modalità offline */}
        {!isOnline && (
          <div className="pb-4">
            <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
                <span className="text-sm text-orange-800 font-medium">
                  Modalità Offline - Gli ordini verranno sincronizzati automaticamente
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WizardProgressBar;